import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Result, Button } from 'antd'

const NotFound = () => {
  let navigate = useNavigate()
  return (
    <Result
      status="404"
      title="404"
      subTitle="对不起，您访问的页面不存在"
      extra={
        <Button
          type="primary"
          onClick={() => {
            navigate('/')
          }}>
          回到首页
        </Button>
      }
    />
  )
}

export default NotFound
